import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="container-fluid p-3 d-flex justify-content-center align-items-center  footer">
      <h4>Task Manager</h4> &nbsp; <p className="m-0">&copy;all rights reserved</p>
    </div>
  );
};

export default Footer;
